import styled from "styled-components";

export const Wrapper = styled.div`
    padding: 50px 10px 100px;
    font-size: 18px;
    @media (min-width: 768px) {
        //padding: 150px 10px 200px;
        font-size: 26px;
        font-family: 'Manrope';
    }
`

export const Pink = styled.strong`
    color: #E46DD6;
    font-weight: 700;
`;

export const Gold = styled.strong`
    color: rgb(194, 143, 90);
    font-weight: 700;
`;

export const StoreText = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
`;

export const StoreTextSmall = styled.div`
  font-size: 14px;
  margin-bottom: 2px;
`;

export const StoreTextStrong = styled.div`
  margin-top: -2px;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #feffff;
`;

export const StoreButtonBase = styled.a`
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 16px;
  border-radius: 0.5rem;
  text-decoration: none;
  cursor: pointer;
  color: #feffff;
  background-color: rgb(194 143 90 / 54%);

  @media (min-width: 640px) {
    flex-direction: row;
  }
`;

export const GoogleIcon = styled.svg`
  width: 28px;
  height: 28px;
  margin-right: 8px;
  color: #feffff;
`;

export const StoreButton = styled(StoreButtonBase)`
  border: none;
  margin-top: 50px;
  width: 300px;

  &:hover {
    filter: brightness(1.05);
  }
`;

export const Section = styled.p``